export const Bio = {
  name: "Adebayo Omobolaji Abiodun",
  initials: "AO",
  title: "Lead Software Engineer",
  location: "Lagos, Nigeria",
  email: "AdebayoAbiodunOmobolaji@gmail.com",
  phone: "+234 811 633 6975",
  roles: [
    "Lead Software Engineer",
    "Full Stack Developer",
    "Backend Engineer",
    "IT Infrastructure Specialist",
    "ML Engineer",
  ],
  description:
    "Software Engineer and IT Infrastructure Specialist with 7+ years building and running production systems across fintech, healthtech, proptech, and legal tech. I focus on solid architecture, reliable infrastructure, and mentoring the engineers I work with.",
  longDescription:
    "At Visiara Ltd, I lead architecture and delivery for our software products, from system design through production rollout. I have 7+ years of backend and full-stack engineering experience, plus hands-on IT infrastructure work: Linux administration, VPN hosting, cloud identity across Azure, AWS, and GCP, and observability tooling. I hold ITIL 4 Foundation and CompTIA Security+ certifications, and I spend time mentoring the engineers on my team.",
  github: "https://github.com/jayson7",
  resume:
    "https://drive.google.com/file/d/101vwD6c2_rSjXOQ395hg1M1vHSWyIR0z/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/abiodunadebayo8",
  twitter: "https://twitter.com/dev_jayson",
  insta: "https://www.instagram.com/dev_jayson/",
  facebook: "https://www.facebook.com/adebayo.mobolaji.18",
};

export const stats = [
  { id: 0, label: "Years of Experience", value: 7, suffix: "+" },
  { id: 1, label: "Active Sites in Production", value: 27, suffix: "+" },
  { id: 2, label: "Users Served", value: 10000, suffix: "+" },
  { id: 3, label: "Certifications Earned", value: 5, suffix: "" },
];

const devicon = (path) => `https://cdn.jsdelivr.net/gh/devicons/devicon/icons/${path}`;

const reactLogo =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K";

export const skills = [
  {
    title: "Languages",
    skills: [
      { name: "Python", image: devicon("python/python-original.svg") },
      { name: "JavaScript", image: devicon("javascript/javascript-original.svg") },
      { name: "TypeScript", image: devicon("typescript/typescript-original.svg") },
      { name: "PHP", image: devicon("php/php-original.svg") },
      { name: "C#", image: devicon("csharp/csharp-original.svg") },
      { name: "Kotlin", image: devicon("kotlin/kotlin-original.svg") },
    ],
  },

  {
    title: "Backend",
    skills: [
      { name: "Django", image: devicon("django/django-plain.svg") },
      { name: "Django REST", image: devicon("django/django-plain.svg") },
      { name: "FastAPI", image: devicon("fastapi/fastapi-original.svg") },
      { name: "Laravel", image: devicon("laravel/laravel-original.svg") },
      { name: "Node.js", image: devicon("nodejs/nodejs-original.svg") },
    ],
  },

  {
    title: "Frontend & Mobile",
    skills: [
      { name: "React JS", image: reactLogo },
      { name: "Next.js", image: devicon("nextjs/nextjs-original.svg") },
      { name: "React Native", image: reactLogo },
      { name: "Flutter", image: devicon("flutter/flutter-original.svg") },
      { name: ".NET MAUI", image: devicon("dotnetcore/dotnetcore-original.svg") },
    ],
  },

  {
    title: "Cloud & DevOps",
    skills: [
      { name: "AWS", image: devicon("amazonwebservices/amazonwebservices-original-wordmark.svg") },
      { name: "Azure", image: devicon("azure/azure-original.svg") },
      { name: "GCP", image: devicon("googlecloud/googlecloud-original.svg") },
      { name: "Docker", image: devicon("docker/docker-original.svg") },
      { name: "Kubernetes", image: devicon("kubernetes/kubernetes-plain.svg") },
      { name: "Linux", image: devicon("linux/linux-original.svg") },
    ],
  },

  {
    title: "Databases & Caching",
    skills: [
      { name: "PostgreSQL", image: devicon("postgresql/postgresql-original.svg") },
      { name: "MySQL", image: devicon("mysql/mysql-original.svg") },
      { name: "MongoDB", image: devicon("mongodb/mongodb-original.svg") },
      { name: "Redis", image: devicon("redis/redis-original.svg") },
      { name: "Memcached", image: devicon("memcached/memcached-original.svg") },
    ],
  },

  {
    title: "Messaging & Observability",
    skills: [
      { name: "Kafka", image: devicon("apachekafka/apachekafka-original.svg") },
      { name: "Prometheus", image: devicon("prometheus/prometheus-original.svg") },
      { name: "Grafana", image: devicon("grafana/grafana-original.svg") },
    ],
  },

  {
    title: "AI & Machine Learning",
    skills: [
      { name: "PyTorch", image: devicon("pytorch/pytorch-original.svg") },
      { name: "TensorFlow", image: devicon("tensorflow/tensorflow-original.svg") },
      { name: "Scikit-learn", image: devicon("scikitlearn/scikitlearn-original.svg") },
      { name: "Pandas", image: devicon("pandas/pandas-original.svg") },
      { name: "NumPy", image: devicon("numpy/numpy-original.svg") },
    ],
  },

  {
    title: "Design & Tooling",
    skills: [
      { name: "Git", image: devicon("git/git-original.svg") },
      { name: "Figma", image: devicon("figma/figma-original.svg") },
      { name: "Postman", image: devicon("postman/postman-original.svg") },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://res.cloudinary.com/jaytech/image/upload/v1714576638/rfp_pm2zwn.png",
    role: "Lead Software Engineer",
    company: "Visiara Ltd",
    date: "Feb 2026 – Present",
    desc: "Lead architecture and delivery of scalable software products at Visiara Ltd, overseeing the full SDLC from design through to production deployment. Establish engineering best practices, code review standards, and CI/CD pipelines to improve team velocity and code quality. Mentor junior engineers and foster a culture of continuous learning and engineering excellence.",
    skills: [
      "System Architecture",
      "CI/CD",
      "Docker",
      "Kubernetes",
      "Python",
      "React",
      "Node.js",
      "PostgreSQL",
    ],
  },

  {
    id: 1,
    img: "https://res.cloudinary.com/jaytech/image/upload/v1714576638/rac_bsvmpe.jpg",
    role: "IT Specialist / System Engineer",
    company: "Ecobank Transnational Incorporated",
    date: "Nov 2022 – Feb 2026",
    desc: "Maintained enterprise IT infrastructure serving head office and all branch locations of this pan-African banking conglomerate, achieving 99.9% system uptime across production environments. Administered Windows and Linux servers (expert level), led IT governance and compliance initiatives reducing infrastructure vulnerabilities by 30%, and designed VPN server infrastructure for secure remote access.",
    skills: [
      "Azure",
      "GCP",
      "AWS",
      "Linux",
      "System Security",
      "VPN Hosting",
      "Python",
      "ITIL 4",
      "CompTIA Sec+",
    ],
  },

  {
    id: 2,
    img: "https://res.cloudinary.com/jaytech/image/upload/v1714576619/ithrive_z4q7rb.jpg",
    role: "Software Developer (Contract)",
    company: "Chudisoft",
    date: "May 2022 – Aug 2022",
    desc: "Architected and delivered an Estate Management Software platform adopted by 500+ residents, improving property management efficiency by 40%. Designed and deployed a Pregnancy Disease Detection Application serving 10,000+ users, integrating ML-based diagnostic support built with PyTorch. Rebuilt and maintained the company public website, increasing user engagement by 25%.",
    skills: [
      "Python",
      "Django",
      "PyTorch",
      "React",
      "PHP",
      "Laravel",
      "MySQL",
    ],
  },

  {
    id: 3,
    img: "https://res.cloudinary.com/jaytech/image/upload/v1714852686/saapade_acvsw0.jpg",
    role: "Python Programming Facilitator",
    company: "MumsWhoCode",
    date: "Jul 2021 – Oct 2022",
    desc: "Trained and mentored 50+ women in Python programming and backend development, achieving a 90% programme completion rate. Designed a comprehensive backend curriculum focused on practical projects and job-market readiness for mothers across Africa.",
    skills: ["Python", "Django", "HTML", "CSS", "JavaScript", "Bootstrap"],
  },

  {
    id: 4,
    img: "https://res.cloudinary.com/jaytech/image/upload/v1714850289/Screenshot_from_2024-02-18_05-58-25_yvy4w1.png",
    role: "Backend Engineer",
    company: "MyFinPad!",
    date: "2018 – 2020",
    desc: "Developed and optimised backend modules for an SME financial management platform, improving system efficiency by 20%. Conducted structured QA testing and introduced defect tracking processes, reducing production bugs by 15%. Migrated legacy application components to modern, scalable web technologies.",
    skills: [
      "Python",
      "Django",
      "Django REST Framework",
      "PostgreSQL",
      "MySQL",
      "React",
      "Docker",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://miva-university.s3.eu-west-2.amazonaws.com/wp-content/uploads/2023/05/15103605/Logo-5.png",
    school: "MIVA Open University, Abuja",
    date: "2024 – 2026 (Currently Enrolled)",
    grade: "4.58 CGPA",
    desc: "Currently pursuing a Bachelor of Science (BSc) in Accounting at MIVA Open University, Abuja.",
    degree: "BSc Accounting (In Progress)",
  },
  {
    id: 1,
    img: "https://res.cloudinary.com/jaytech/image/upload/v1714852686/saapade_acvsw0.jpg",
    school: "Gateway Polytechnic, Ogun State",
    date: "Aug 2014 – Sep 2016",
    grade: "2.51 CGPA",
    desc: "Studied Financial Accounting at Gateway Polytechnic Saapade, graduating with a National Diploma in Financial Accounting in 2016.",
    degree: "ND, Financial Accounting",
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/jaytech/image/upload/v1714852686/comlag_b9c1l3.jpg",
    school: "Command Secondary School, Ipaja Lagos",
    date: "Sept 2006 – Aug 2012",
    desc: "Completed Senior Secondary School education at Command Secondary School, Lagos.",
    degree: "SSCE",
  },
];

export const certifications = [
  {
    id: 0,
    title: "CompTIA Security+ (SY0-601)",
    issuer: "CompTIA",
    year: "2025",
    color: "#854CE6",
  },
  {
    id: 1,
    title: "ITIL 4 Foundation",
    issuer: "PeopleCert / Axelos",
    year: "2024",
    color: "#854CE6",
  },
  {
    id: 2,
    title: "Cisco Certified Network Associate (CCNA)",
    issuer: "Cisco",
    year: "2016",
    color: "#854CE6",
  },
  {
    id: 3,
    title: "Full Stack Web Developer Certification",
    issuer: "freeCodeCamp",
    year: "2019",
    color: "#854CE6",
  },
  {
    id: 4,
    title: "Quality Assurance & SQL Certifications",
    issuer: "HackerRank",
    year: "2019",
    color: "#854CE6",
  },
];

export const projects = [
  {
    id: -2,
    title: "FMT Prime: HeckerHub Facilities Management",
    date: "2026 – Present",
    description:
      "Multi-site facilities and property management platform operating across 27 active sites. It unifies property records, finance, maintenance workflows, inventory, resident management, and bookings within a single portfolio dashboard, secured with role-based access control and protected session handling.",
    tags: ["PHP", "Laravel", "MySQL", "React"],
    category: "web app",
    featured: true,
    github: "https://github.com/jayson7",
    webapp: "https://fmt-prime.heckerpeople.app",
  },

  {
    id: -1,
    title: "TIMATEND: Biometric Payroll & Attendance",
    date: "2026 – Present",
    description:
      "Biometric identification system automating payroll processing, time capture, and attendance reconciliation, built with separate employee and administrator portals for staff self-service biodata management and centralised workforce administration.",
    tags: ["PHP", "Laravel", "MySQL", "Biometric Integration"],
    category: "web app",
    featured: true,
    github: "https://github.com/jayson7",
    webapp: "https://timatend.com",
  },

  {
    id: 0,
    title: "HeckerPeople: Time & Attendance SaaS",
    date: "2023 – Present",
    description:
      "Cloud-based workforce management SaaS platform featuring time tracking, attendance, leave management, employee scheduling, and payroll-ready reporting. Built for multi-organisation deployment.",
    tags: ["PHP", "Laravel", "React", "MySQL"],
    category: "web app",
    featured: true,
    github: "https://github.com/jayson7",
    webapp: "https://heckerpeople.app/employee",
  },

  {
    id: 1,
    title: "UNILAG ERP System",
    date: "2022 – 2023",
    description:
      "Enterprise Resource Planning system for the University of Lagos, integrating academic administration, HR, finance, and operations management into a unified institutional platform.",
    tags: ["Python", "Django", "React", "PostgreSQL"],
    category: "web app",
    github: "https://github.com/jayson7",
    webapp: "https://github.com/jayson7",
  },

  {
    id: 2,
    title: "Estate Management Software",
    date: "2022",
    description:
      "Full-featured property management platform serving 500+ residents with resident portals, payment tracking, maintenance request workflows, and admin dashboards.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1714576619/ithrive_z4q7rb.jpg",
    tags: ["PHP", "Laravel", "MySQL"],
    category: "web app",
    github: "https://github.com/jayson7",
    webapp: "https://github.com/jayson7",
  },

  {
    id: 3,
    title: "Pregnancy Disease Detection App",
    date: "2022",
    description:
      "ML-assisted healthcare application used by 10,000+ users for early detection and guidance on pregnancy-related conditions, leveraging deep learning models built with PyTorch and TensorFlow for diagnostic support.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1714576638/rfp_pm2zwn.png",
    tags: ["Python", "Django", "PyTorch", "TensorFlow"],
    category: "AI & Others",
    github: "https://github.com/Jayson7/rfpAlgorithm.git",
    webapp: "https://rfp-algorithm.vercel.app",
  },

  {
    id: 4,
    title: "WPM2: Workflow Management System",
    date: "2022 – 2023",
    description:
      "Automated task and workflow management platform with configurable approval flows and real-time event streaming via Kafka. Supports multi-team collaboration with role-based access control.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1714576658/wpm_mc5nqx.jpg",
    tags: ["Node.js", "React", "PostgreSQL", "Kafka"],
    category: "web app",
    github: "https://github.com/Jayson7/wpm",
    webapp: "https://wpm2.vercel.app/",
  },

  {
    id: 5,
    title: "MyFinPad!",
    date: "2018 – 2020",
    description:
      "SME-focused financial tracking and reporting platform providing budgeting, expense tracking, and business analytics dashboards for Nigerian small and medium enterprises.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1714850289/Screenshot_from_2024-02-18_05-58-25_yvy4w1.png",
    tags: ["Python", "Django REST Framework", "PostgreSQL", "React"],
    category: "web app",
    github: "https://github.com/jayson7",
    webapp: "https://github.com/jayson7",
  },

  {
    id: 6,
    title: "RFP Algorithm",
    date: "Jun 2023 – Jul 2024",
    description:
      "A web application that presents a quiz to pregnant mothers and women in general to generate diagnostic results based on answers given, with downloadable reports for designated doctors.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1714576638/rfp_pm2zwn.png",
    tags: ["MongoDB", "Django", "Bootstrap", "HTML", "CSS", "JavaScript"],
    category: "web app",
    github: "https://github.com/Jayson7/rfpAlgorithm.git",
    webapp: "https://rfp-algorithm.vercel.app",
  },

  {
    id: 7,
    title: "Royalace",
    date: "Apr 2022 – May 2023",
    description:
      "A web application built for a construction company based in Lagos, covering all aspects of construction including houses and roads.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1714576638/rac_bsvmpe.jpg",
    tags: ["Django", "Bootstrap", "HTML", "CSS", "JavaScript"],
    category: "web app",
    github: "https://github.com/Jayson7/royalace.org.git",
    webapp: "https://royalace-org.vercel.app",
  },

  {
    id: 8,
    title: "Ithrive FX",
    date: "Aug 2022 – Sep 2023",
    description:
      "Forex training platform helping enthusiasts develop skills in technical analysis, trading psychology, money management, and market strategy.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1714576619/ithrive_z4q7rb.jpg",
    tags: ["Django", "Bootstrap", "HTML", "CSS", "JavaScript"],
    category: "web app",
    github: "https://github.com/Jayson7/ithrive_FX.git",
    webapp: "https://ithrive-fx.vercel.app",
  },

  {
    id: 9,
    title: "JDD Law Solicitors & Advocates",
    date: "Jan 2023 – Mar 2023",
    description:
      "Professional legal services website for a solicitors and advocates firm, with a modern design and clear service presentation.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1714851366/Screenshot_from_2024-03-15_03-26-16_duni2x.png",
    tags: ["Django", "Bootstrap", "HTML", "CSS", "JavaScript"],
    category: "web app",
    github: "https://github.com/Jayson7/jddlawsolicitorsandadvocates",
    webapp: "https://www.jddlawsolicitorsadvocate.com",
  },

  {
    id: 10,
    title: "BigBox Music Player",
    date: "Mar 2025",
    description:
      "Sleek and modern music player built with React Native and Expo. Allows users to play music from device storage with onboarding screen, playlist management, and automatic song detection.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1741076983/oypsquakfe4aiy8p38dg.png",
    tags: ["React Native", "Expo"],
    category: "android app",
    github: "https://github.com/Jayson7/BigBox-Music-Player.git",
    webapp: "https://github.com/Jayson7/BigBox-Music-Player.git",
  },

  {
    id: 11,
    title: "Beauty Shop",
    date: "Dec 2020 – Jan 2021",
    description:
      "Hybrid mobile app for a beauty product shop combining React Native and Sanity CMS, featuring product catalogue, cart, and order management.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1714850289/Screenshot_from_2024-02-18_05-58-25_yvy4w1.png",
    tags: ["React Native", "Django REST Framework", "MongoDB"],
    category: "android app",
    github: "https://github.com/Jayson7/beautyApp.git",
  },

  {
    id: 12,
    title: "Face Recognition App",
    date: "Jan 2021",
    description:
      "A face recognition Python app built with OpenCV and the face_recognition library. Uses webcam to detect and identify faces in real time.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1741076982/m1ssm6gkzk1dp877oxli.png",
    tags: ["Python", "OpenCV"],
    category: "AI & Others",
    github: "https://github.com/Jayson7/lets-write-face-recognition.git",
    webapp: "https://github.com/Jayson7/lets-write-face-recognition.git",
  },

  {
    id: 13,
    title: "AI Chatbot",
    date: "Mar 2021",
    description:
      "Advanced chatbot built with ChatterBot trainers, capable of conversational responses and learning from interaction data.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1743348284/Screenshot_at_2025-03-30_16-22-57_gvn24f.png",
    tags: ["Python"],
    category: "AI & Others",
    github:
      "https://github.com/Jayson7/AI-dummy-projects/blob/master/chatbot/version%201/main.py",
    webapp:
      "https://github.com/Jayson7/AI-dummy-projects/blob/master/chatbot/version%201/main.py",
  },

  {
    id: 14,
    title: "AI Voice Assistant",
    date: "Mar 2021",
    description:
      "Advanced voice assistant built with multiple APIs enabling task execution, web search, weather updates, and natural language responses.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1743348284/Screenshot_at_2025-03-30_16-13-22_iqsmna.png",
    tags: ["Python"],
    category: "AI & Others",
    github:
      "https://github.com/Jayson7/AI-dummy-projects/tree/master/AI-Personal-Voice-assistant-using-Python-master",
    webapp:
      "https://github.com/Jayson7/AI-dummy-projects/tree/master/AI-Personal-Voice-assistant-using-Python-master",
  },

  {
    id: 15,
    title: "Advance Portfolio",
    date: "Jan 2020",
    description:
      "Personal developer portfolio showcasing projects, skills, and experience with a clean, responsive design.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1742731627/Screenshot_at_2025-03-23_12-53-47_uyomqa.png",
    tags: ["HTML", "CSS", "JavaScript"],
    category: "web app",
    github: "https://github.com/Jayson7/personal-portfolio",
    webapp: "https://jaysons.netlify.app/",
  },

  {
    id: 16,
    title: "Jayson Technologies Website",
    date: "Jan 2020",
    description:
      "A well-formed business website for Jayson Technologies, a software development and IT services company.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1742731628/Screenshot_at_2025-03-23_13-04-17_nmz6mh.png",
    tags: ["HTML", "CSS", "JavaScript"],
    category: "web app",
    github: "https://github.com/Jayson7/JaysonTechnologies.git",
    webapp: "https://jaysontechs.netlify.app",
  },

  {
    id: 17,
    title: "Flowerish",
    date: "Jan 2020",
    description: "E-commerce floral shop website. All things grow with love.",
    image:
      "https://res.cloudinary.com/jaytech/image/upload/v1742775421/Screenshot_at_2025-03-24_01-16-44_b5a0st.png",
    tags: ["HTML", "CSS", "JavaScript"],
    category: "web app",
    github: "https://github.com/Jayson7/flowerish",
    webapp: "https://flowerish.netlify.app/",
  },
];

export const TimeLineData = [
  { year: 2018, text: "Started backend engineering at MyFinPad!" },
  { year: 2019, text: "Earned Full Stack & HackerRank certifications" },
  { year: 2021, text: "Facilitated Python training for 50+ women at MumsWhoCode" },
  { year: 2022, text: "Joined Ecobank as IT Specialist / System Engineer" },
  { year: 2025, text: "Earned CompTIA Security+ certification" },
  { year: 2026, text: "Promoted to Lead Software Engineer at Visiara Ltd" },
];
